import { HTTPClient } from '../utils/request'

export default {
  get: ({ query }) => HTTPClient.get(`/is_exist${query}`),
}
